import axios from "axios";

export const getTimeZones = async (): Promise<string[]> => {
  const res = await axios.get<string[]>("/system/time-zones");
  return res.data;
};
